const SHOW_EXPORT_POPUP = 'SHOW_EXPORT_POPUP';
const ERROR_GENERATING_REPORT = 'ERROR_GENERATING_REPORT';
const SUCCESS_GENERATING_REPORT = 'SUCCESS_GENERATING_REPORT';

export const GENERATE_EXPORT = 'GENERATE_EXPORT';
export const DOWNLOAD_REPORT = 'DOWNLOAD_REPORT';

const initialState = {
  showDashboardExportPopup: false, // wrapper that displays the white modal
  showPopupSpinnerView: false, // spinner displayed while generating report
  showPopupDatePickerView: true, // default datepicker form
  showPopupDownloadView: false, // download view with csv/xsl links
  showPopupErrorView: false, // error view in case something went wrong along the way.
  reportId: '', // a successful generation stores the info for the report here.
  format: '' // the format for the download.
};

export const exportReducer = (exportState = initialState, action = null) => {
  switch (action && action.type) {
    case SHOW_EXPORT_POPUP: // display the initial popup
      return {
        ...initialState, // reset popup to form each time it's launched
        showDashboardExportPopup: action.payload.showDashboardExportPopup
      };

    case GENERATE_EXPORT: // hide the form, and show the spinner
      return {
        ...exportState,
        showPopupSpinnerView: true,
        showPopupDatePickerView: false,
        showPopupDownloadView: false,
        showPopupErrorView: false
      };

    case ERROR_GENERATING_REPORT: // error view
      return {
        ...exportState,
        showPopupSpinnerView: false,
        showPopupDatePickerView: false,
        showPopupDownloadView: false,
        showPopupErrorView: true
      };

    case SUCCESS_GENERATING_REPORT: // success view
      return {
        ...exportState,
        showPopupSpinnerView: false,
        showPopupDatePickerView: false,
        showPopupDownloadView: true,
        showPopupErrorView: false,
        reportId: action.payload.reportId
      };

    case DOWNLOAD_REPORT:
      return {
        ...exportState,
        reportId: action.payload.reportId,
        format: action.payload.format
      };

    default:
      return exportState;
  }
};

export const exportSelectors = {
  showDashboardExportPopup: (state) => state.export.showDashboardExportPopup,
  showPopupSpinnerView: (state) => state.export.showPopupSpinnerView,
  showPopupDatePickerView: (state) => state.export.showPopupDatePickerView,
  showPopupDownloadView: (state) => state.export.showPopupDownloadView,
  showPopupErrorView: (state) => state.export.showPopupErrorView,
  reportId: (state) => state.export.reportId
};

export const exportActions = {
  setExportPopupView: (showDashboardExportPopup) => ({
    type: SHOW_EXPORT_POPUP,
    payload: { showDashboardExportPopup }
  }),
  generateExport: (startDate, endDate) => ({
    type: GENERATE_EXPORT,
    payload: { startDate: startDate, endDate: endDate }
  }),
  errorGeneratingExport: (error) => ({
    type: ERROR_GENERATING_REPORT,
    payload: { error: error }
  }),
  successGeneratingExport: (reportId) => ({
    type: SUCCESS_GENERATING_REPORT,
    payload: { reportId: reportId }
  }),
  downloadReport: (reportId, format) => ({
    type: DOWNLOAD_REPORT,
    payload: { reportId: reportId, format: format }
  })
};



// WEBPACK FOOTER //
// ./src/modules/launchpad/reducer/export-reducer.js